import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useI18n } from '../../../../../i18n';
import Toggle from '../../../general/form/Toggle';
import { actions } from '../../../../redux/app/deviceTrace';
import { ReduxKeyContext } from '../../../../misc/ReduxKeyContext';

/**
 * Map options control switching widgets visibility.
 * @param {Object} props
 * @param {string} [props.label]
 */

function MapOptionDisplayTraceDirection(props) {
	const { f } = useI18n();
	const reduxKey = useContext(ReduxKeyContext);
	const display = useSelector(state => state.deviceTrace[reduxKey] && state.deviceTrace[reduxKey].displayDirection);
	const dispatch = useDispatch();

	const onChangeDisplay = (value) => {
		dispatch(actions.setDisplayDirection({ domain: reduxKey, display: value }));
	}

	return (
		<div className="map-option map-device-trace-direction">
			<Toggle
				label={props.label || f('show trace direction')}
				value={display}
				onChange={onChangeDisplay}
			/>
		</div>
	);
}

export default MapOptionDisplayTraceDirection;
